import { render, staticRenderFns } from "./TopicTrial.vue?vue&type=template&id=531330f0&scoped=true&"
import script from "./TopicTrial.vue?vue&type=script&lang=js&"
export * from "./TopicTrial.vue?vue&type=script&lang=js&"
import style0 from "./TopicTrial.vue?vue&type=style&index=0&id=531330f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531330f0",
  null
  
)

export default component.exports